import { Box, Switch, Typography } from "@mui/material";
import React from "react";
import { useIntl } from "react-intl";

const AverageHub = ({
    showAverage,
    setShowAverage,
}: {
    showAverage: boolean;
    setShowAverage: (event: React.ChangeEvent<HTMLInputElement>) => void;
}) => {
    const intl = useIntl();

    return (
        <Box
            sx={(theme) => ({
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                [theme.breakpoints.down("lg")]: {
                    flexWrap: "wrap",
                },
            })}
        >
            <Typography
                variant="subtitle2"
                sx={(theme) => ({
                    color: "text.secondary",
                    [theme.breakpoints.down("lg")]: {
                        mb: 1,
                    },
                })}
            >
                {intl.formatMessage({ id: "behaviouralComparison.selectProfiles" })}
            </Typography>
            <Box display="flex" alignItems="center">
                <Typography sx={{ fontSize: 12, letterSpacing: "1.25px" }}>
                    {intl.formatMessage({ id: "behaviouralComparison.displayAverages" })}
                </Typography>
                <Switch size="small" checked={showAverage} onChange={setShowAverage} />
            </Box>
        </Box>
    );
};

export default AverageHub;
